import React, { useState, useEffect } from 'react';
import { getFormattedPriceObject } from '@/helpers/currencyHelpers';
import { useCurrencyConverter } from '@/hooks/currencyConverter.hook';
import { useFetchAllSpacesSubtypeRelationships } from '@/services/spacesSubtypeRelationshipService';
import { useFetchAllBlogs } from '@/services/blogService';

export const useHome = (searchFormData, lenguage) => {
  const [isLoading, setIsLoading] = useState(true);
  const [spacesDataFromBackend, setSpacesDataFromBackend] = useState([]);
  const [blogsDataFromBackend, setBlogsDataFromBackend] = useState([]);
  const { convert } = useCurrencyConverter();

  const { data: spacesData } = useFetchAllSpacesSubtypeRelationships();
  const { data: blogsData } = useFetchAllBlogs();

  const formatSpacesData = (spacesData) => {
    console.log('Estamos jere');
    const sortedData = [...spacesData];
    const orderedSpacesDataByLanguage =
      lenguage === 'ES'
        ? sortedData.sort((a, b) => {
            if (a.space_id === 151 && b.space_id !== 151) return -1;
            if (a.space_id !== 151 && b.space_id === 151) return 1;
            return 0;
          })
        : sortedData.sort((a, b) => {
            if (a.space_id === 154 && b.space_id !== 154) return -1;
            if (a.space_id !== 154 && b.space_id === 154) return 1;
            return 0;
          });

    const enrichedSpacesData = orderedSpacesDataByLanguage.map((space) => {
      const formattedPriceObject = getFormattedPriceObject(space, lenguage, convert);
      return {
        ...space,
        calculatedPrice: formattedPriceObject?.calculatedPrice,
        currency: formattedPriceObject?.currency,
        formattedPrice: formattedPriceObject?.formattedPrice,
      };
    });

    setSpacesDataFromBackend(enrichedSpacesData);
  };

  useEffect(() => {
    if (spacesData) {
      formatSpacesData(spacesData);
    }

    if (blogsData) {
      setBlogsDataFromBackend(blogsData);
    }

    if (spacesData && blogsData) {
      setIsLoading(false);
    }
  }, [spacesData, blogsData]);

  useEffect(() => {
    if (spacesData) {
      console.log('lenguage cambió, recalculando precios:', lenguage);
      formatSpacesData(spacesData);
    }
  }, [lenguage]);

  return {
    isLoading,
    setIsLoading,
    spacesDataFromBackend,
    blogsDataFromBackend,
  };
};
